import { render } from "./headmodal.vue?vue&type=template&id=cdaeb056"
import script from "./headmodal.vue?vue&type=script&lang=js"
export * from "./headmodal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__